<template>
    <div class="accounting-book-filter" :class="{ open: openState}" v-bind:style="{'top': filterTop}">
        <div class="accounting-book-filter-wrap" v-bind:style="{'min-height': myHeight}">
            <div class="filter-title">
                <img src="@/assets/img/icon/filter_gray.svg" alt="">
                篩選
                <span v-show="filterState" class="clear-filter" @click="setFilterDefault">
                    清除篩選
                </span>
            </div>
            <div class="default buildin-type">
                <div class="title level1-title-font">收支類別</div>
                <rent-select refName="type" selectMsg="所有類別" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filterTypeIsEmpty">
                    <ul>
                        <li data-id="INCOME">
                            收入
                        </li>
                        <li data-id="EXPENSE">
                            支出
                        </li>
                        
                    </ul>
                </rent-select>
            </div>
            <div class="default location">
                <div class="title level1-title-font">房源名稱</div>
                <rent-select refName="houseName"  class="select-scroll" selectMsg="所有房源" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="filterHouseNameIsEmpty">
                    <ul>
                        <li :data-id="list.houseName" v-for="(list,index) in houseList" :key="index">
                            {{list.houseName}}
                        </li>
                    </ul>
                </rent-select>
            </div>
            <div class="default rent">
                <div class="title level1-title-font">記帳金額</div>
                <vue-slider v-model="incomeFilter.amount" :min="0" :max="100000" :width="214" :height="2" tooltip="always" :tooltip-placement="'bottom'" :tooltip-formatter="val => numValue(val)" :enableCross="true"/>
            </div>
            <div class="default date">
                <div class="title level1-title-font">記帳時間</div>
                <date-picker v-model="incomeFilter.date" :class="{'active': incomeFilter.date != ''}" placeholder="請選擇日期" value-type="YYYY-MM-DD" format="YYYY.MM.DD"></date-picker>
            </div>
            <div class="result">
                <div class="view-result" @click="filterClose">
                    查看搜尋結果  {{filterResultTotal}}
                </div>
            </div>
        </div>
        <span class="close" @click="filterClose">
            <img src="@/assets/img/icon/cross_white.svg" alt="">
        </span>
    </div>
</template>
<script>
import VueSlider from 'vue-slider-component'
import '@/assets/css/rent.css'
import RentSelect from '@/components/widge/RentSelect.vue';
import VueRangeSlider from 'vue-range-component'
import DatePicker from 'vue2-datepicker';
import { mapGetters } from 'vuex'
import { 
    apiGetHouseMgtList
    } from "@/apis/api.js";
export default {
    data () {
        return {
            openState: this.isOpen,
            incomeFilter: {
                houseName: null,
                type: null,
                amount: [0, 100000],
                date: null,
            },
            houseList: [],
            isDefault: false,
            filterState: 0,
            myHeight: (window.innerHeight) + 'px',
            filterTop: null,
        }
    },
    created () {
        this.formatter = value => {
            if( value >= 100000){
                return `$${value}+`
            }else{
                return `$${value}`
            }
        }
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
        this.getHouseList()
    },
    destroyed () {
        this.$store.dispatch('setHouseMgtFilterDefault')
    },
    props: {
        isOpen: Boolean,
    },
    watch: {
        isOpen (val) {
            this.openState = val
        },
        incomeFilter: {
            handler: function (val) {
                this.$emit('changeFilter', val)
                this.filterState = 1
            },
            deep: true
        },
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            this.filterTop = (scrollTop-163) + 'px'
                
        },
        getHouseList: function () {
            apiGetHouseMgtList()
            .then(res => {
                // console.log(res)
                if( res.data.status == "SUCCESS" ){
                    // console.log(res)
                    if(res.data.result.houseList != undefined){
                        this.houseList = res.data.result.houseList
                    }
                }
            })
            .catch(err => {
                console.log(err)
            })
        },
        setFilterDefault: function () {
            this.incomeFilter = {
                houseName: null,
                type: null,
                amount: [0, 100000],
                date: null,
            },
            setTimeout(()=>{
                this.filterState = 0
            },100)
        },
        filterClose: function () {
            this.$emit('filterClose', false);
        },
        getSelectId: function (value) {
            if( value.ref == 'houseName' ){
                this.incomeFilter.houseName = value.id
            }else if( value.ref == 'type' ){
                this.incomeFilter.type = value.id
            }
        },
        numValue: function (val) {
            if( val == '100000' ){
                return '$'+this.toCurrency(val)+'+'
            }else{
                return '$'+this.toCurrency(val)
            }
        },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // }
    },
    computed: {
        ...mapGetters({
            filterHouseNameIsEmpty: 'GET_ACCOUNTING_BOOK_HOUSE_NAME_IS_EMPTY',
            filterTypeIsEmpty: 'GET_ACCOUNTING_BOOK_TYPE_IS_EMPTY',
            filterSourceIsEmpty: 'GET_ACCOUNTING_BOOK_SOURCE_IS_EMPTY',
            filterResultTotal: 'GET_ACCOUNTING_BOOK_MGT_FILTER_RESULT_TOTAL'
        })
    },
    components: {
        RentSelect,
        VueSlider,
        DatePicker,
    }
}
</script>
<style lang="scss" scoped>
    .accounting-book-filter{
        position: absolute;
        width: 279px;
        box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
        background-color: #ffffff;
        // height: 100%;
        top: -163px;
        right: -350px;
        transition: all 1s ease-in-out;
        z-index: 10;
        .accounting-book-filter-wrap{
            position: relative;
            height: 100%;
            .default{
                padding: 20px;
                border-bottom: 1px solid #f0f0f0;
                .title{
                    margin-bottom: 16px;
                }
            }
            .filter-title{
                display: flex;
                align-items: center;
                padding: 24px;
                color: #a8a5a4;
                border-bottom: 1px solid #f0f0f0;
                img{
                    margin-right: 8px;
                }
                .clear-filter{
                    position: absolute;
                    cursor: pointer;
                    font-size: 12px;
                    color: #ff9275;
                    top: 30px;
                    right: 34px;
                }
            }
            .location{
                .group{
                    display: flex;
                    .rent-select:nth-child(1){
                        margin-right: 10px;
                    }
                    .rent-select{
                        width: 75px;
                        height: 18px;
                    }
                }
            }
            .date{
                .mx-datepicker {
                    width: 230px;
                    .mx-input-wrapper{
                        .mx-input{
                            height: 46px;
                            border-radius: 4px;
                            border: solid 1px #e0dfde;
                            color: #a8a5a4;
                            padding: 13px 16px;
                            box-shadow: none;
                        }
                        .mx-icon-calendar,
                        .mx-icon-clear{
                            right: 18px;
                        }
                    }
                }
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
                .mx-datepicker:hover{
                    .mx-input-wrapper{
                        .mx-input{
                            border: 1px solid #676362 !important;
                            color: #676362 !important;
                        }
                    }
                }
            }
            .deposit,
            .rent{
                padding-bottom: 40px;
            }
            .result{
                position: absolute;
                width: 100%;
                height: 76px;
                bottom: 0px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-shadow: 0 4px 20px 0 rgba(37, 38, 94, 0.1);
                .view-result{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #ffffff;
                    font-weight: 500;
                    width: 231px;
                    height: 44px;
                    border-radius: 4px;
                    background-color: #ff9275;
                    cursor: pointer;
                }
            }
        }
        .close{
            position: absolute;
            width: 30px;
            height: 44px;
            background-color: #ff9275;
            border-radius: 10px 0 0 10px;
            left: -30px;
            top: 50%;
            transform: translateY(-50%);
            display: flex;
            align-items: center;
            justify-content: center;
            img{
                cursor: pointer;
            }
        }
    }
    .accounting-book-filter.open{
        right: -40px;
    }
    @media screen and (max-width: 1280px) {
        .accounting-book-filter.open{
            right: 24px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/financialManagement/accountingBookFilter.vue